import { Text } from '@factorialco/deprecated-design-system'
import type { CommentsCommentFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { EmojiBadge } from './EmojiBadge'

type ReactionsGroupedReaction = CommentsCommentFragment['groupedReactions'][number]

export interface GroupedReaction extends Omit<ReactionsGroupedReaction, 'resourceType'> {}

interface ReactionProps {
  item: GroupedReaction
  resourceId: string
  addReaction: (emojiId: string) => void
  deleteReaction: (id: string, resourceId: string, emojiId: string) => void
}
export interface ReactionItemsProps {
  items: GroupedReaction
}

export interface ReactionsReactionValues {
  authorId: string
  companyId: string
  textCode: string
  resourceId: string
}

export const Reaction = ({ item, resourceId, addReaction, deleteReaction }: ReactionProps) => {
  const handleClick = (code: string) => {
    if (item.selfReactionId) {
      deleteReaction(item.selfReactionId, resourceId, code)
    } else {
      addReaction(code)
    }
  }

  const supporters = () => {
    const list = [...item.supportersList]

    if (item.selfReactionId) list.unshift(i18n.t('reactions.supporters.you'))

    const names = list.reduce((acc, name, index) => {
      if (index === 0) {
        return name
      } else if (index === list.length - 1) {
        return `${acc} ${i18n.t('reactions.supporters.and')} ${name}`
      } else {
        return `${acc}, ${name}`
      }
    }, '')

    return (
      <Text.Normal weight="semibold" size="100">
        {names}&nbsp;
        <Text.Normal size="100">{i18n.t('reactions.supporters.reacted')}</Text.Normal>
      </Text.Normal>
    )
  }

  return (
    <>
      {item.count >= 1 && (
        <EmojiBadge
          selfReaction={!!item.selfReactionId}
          code={item.textCode}
          count={item.count}
          label={supporters()}
          onClick={handleClick}
        />
      )}
    </>
  )
}
